export default __webpack_public_path__ + "static/family-26983139b05e46e844ef638d9d75de3b.png";